module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-01.48f35f3b.svg";